// extracted by mini-css-extract-plugin
export default {"container":"WalletButton_container__hOEUu","containerDisabled":"WalletButton_containerDisabled__7orpN","icon":"WalletButton_icon__R44Vv","text":"WalletButton_text__hXjc9"};